module.exports = __webpack_public_path__ + "assets/media/forgetpassword_sent.aace6430.svg";